var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                ref: "queryCondition",
                staticClass: "searchForm",
                attrs: {
                  model: _vm.queryCondition,
                  "label-position": _vm.labelPosition,
                  "label-width": "150px",
                },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "storeFeedback.report.serialNo"
                                      ),
                                      prop: "reportNo",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.reportNo,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "reportNo",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "queryCondition.reportNo",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("storeFeedback.storeNo"),
                                      prop: "storeNo",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.storeNo,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "storeNo",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "queryCondition.storeNo",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("storeFeedback.storeName"),
                                      prop: "storeName",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.storeName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "storeName",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.storeName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "storeFeedback.feedbackStatus"
                                      ),
                                      prop: "processNode",
                                    },
                                  },
                                  [
                                    _c("ic-select", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        excludes: _vm.excludesValue,
                                        clearable: "",
                                        table: "TT_FEEDBACK",
                                        field: _vm.fieldValue,
                                      },
                                      model: {
                                        value: _vm.queryCondition.processNode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "processNode",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryCondition.processNode",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-collapse-transition",
                      [
                        _vm.isShow
                          ? _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "storeFeedback.dcName"
                                              ),
                                              prop: "tmDcId",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                "table-fields": [
                                                  {
                                                    table: "BASE",
                                                    field: "DC",
                                                  },
                                                  {
                                                    table: "TT_FEEDBACK",
                                                    field: "DIRECT_SUPPLIER",
                                                  },
                                                ],
                                                filterable: "",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition.tmDcId,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "tmDcId",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.tmDcId",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "storeFeedback.supplier"
                                              ),
                                              prop: "tmSupplierId",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  placeholder: _vm.$t("BC.sel"),
                                                  clearable: "",
                                                  filterable: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .tmSupplierId,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "tmSupplierId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.tmSupplierId",
                                                },
                                              },
                                              _vm._l(
                                                _vm.supplierLists,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.tmSupplierId,
                                                    attrs: {
                                                      label: item.supplierName,
                                                      value: item.tmSupplierId,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "storeFeedback.problemLevel"
                                              ),
                                              prop: "problemLevel",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticClass: "handle-input",
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                clearable: "",
                                                table:
                                                  "TT_FEEDBACK_FIRST_CHECK",
                                                field: "PROBLEM_LEVEL",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .problemLevel,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "problemLevel",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.problemLevel",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "责任方",
                                              prop: "finalResponsibleParty",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticClass: "handle-input",
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                clearable: "",
                                                table: "TT_FEEDBACK_REPORT",
                                                field:
                                                  "FINAL_RESPONSIBLE_PARTY",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .finalResponsibleParty,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "finalResponsibleParty",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.finalResponsibleParty",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "storeFeedback.materialName"
                                              ),
                                              prop: "materialName",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticStyle: { width: "100%" },
                                              attrs: { clearable: "" },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .materialName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "materialName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.materialName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "storeFeedback.auditor"
                                              ),
                                              prop: "auditor",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticClass: "handle-input",
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                clearable: "",
                                                placeholder: "审批人",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition.auditor,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "auditor",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.auditor",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "storeFeedback.feedbackChannel"
                                              ),
                                              prop: "sourceCode",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                clearable: "",
                                                table: "TT_FEEDBACK",
                                                field: "QUERY_SOURCE_CODE",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition.sourceCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "sourceCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.sourceCode",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "餐厅提交日期(从)",
                                              prop: "createDateFrom",
                                            },
                                          },
                                          [
                                            _c("el-date-picker", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                type: "date",
                                                placeholder:
                                                  _vm.$t("common.selDate"),
                                                "value-format": "yyyy-MM-dd",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .createDateFrom,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "createDateFrom",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.createDateFrom",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "餐厅提交日期(至)",
                                              prop: "createDateTo",
                                            },
                                          },
                                          [
                                            _c("el-date-picker", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                type: "date",
                                                placeholder:
                                                  _vm.$t("common.selDate"),
                                                "value-format": "yyyy-MM-dd",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .createDateTo,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "createDateTo",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.createDateTo",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "Category Level1",
                                              prop: "categoryLevel1Code",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                table: "BASE",
                                                filterable: "",
                                                field: "CATEGORY_LEVEL1",
                                                clearable: "",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  _vm.queryCondition.categoryLevel2Code =
                                                    null
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .categoryLevel1Code,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "categoryLevel1Code",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.categoryLevel1Code",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "Category Level2",
                                              prop: "categoryLevel2Code",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                table: "BASE",
                                                filterable: "",
                                                multiple: "",
                                                field:
                                                  _vm.queryCondition
                                                    .categoryLevel1Code,
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .categoryLevel2Code,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "categoryLevel2Code",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.categoryLevel2Code",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "扣账月份从",
                                              prop: "debitMonthFrom",
                                            },
                                          },
                                          [
                                            _c("el-date-picker", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                type: "month",
                                                placeholder:
                                                  _vm.$t("common.selDate"),
                                                "value-format": "yyyy-MM",
                                                format: "yyyy-MM",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .debitMonthFrom,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "debitMonthFrom",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.debitMonthFrom",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "扣账月份至",
                                              prop: "debitMonthTo",
                                            },
                                          },
                                          [
                                            _c("el-date-picker", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                type: "month",
                                                placeholder:
                                                  _vm.$t("common.selDate"),
                                                "value-format": "yyyy-MM",
                                                format: "yyyy-MM",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .debitMonthTo,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "debitMonthTo",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.debitMonthTo",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "storeFeedback.report.reportStatus"
                                              ),
                                              prop: "reportStatus",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                table: "TT_FEEDBACK_REPORT",
                                                field: "STATUS",
                                                excludes:
                                                  _vm.reportStatusExclude,
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .reportStatus,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "reportStatus",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.reportStatus",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  {
                    attrs: { type: "flex", justify: "center", align: "middle" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.queryData(1)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.search")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.resetQueryCondition()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.reset")))]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "arrowDown",
                        on: {
                          click: function ($event) {
                            _vm.isShow = !_vm.isShow
                          },
                        },
                      },
                      [
                        _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                        _c("i", {
                          class: _vm.isShow
                            ? "el-icon-arrow-up iconBtn"
                            : "el-icon-arrow-down iconBtn",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          { staticClass: "action-btn-row" },
          [
            _vm.isSUP
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.Feedback - _vm.reportsDelete,
                        expression: "Feedback-reportsDelete",
                      },
                    ],
                    staticClass: "btn",
                    attrs: { size: "mini", type: "danger" },
                    on: {
                      click: function ($event) {
                        return _vm.delReport()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.del")))]
                )
              : _vm._e(),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.Feedback - _vm.reportsDebitsExport,
                    expression: "Feedback-reportsDebitsExport",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.exportExcelDebit },
              },
              [_vm._v(_vm._s(_vm.$t("storeFeedback.report.debitsExport")))]
            ),
          ],
          1
        ),
        _c(
          "el-table",
          {
            ref: "table",
            staticClass: "table",
            attrs: {
              data: _vm.tableData,
              border: "",
              "max-height": "420",
              "highlight-current-row": "",
            },
          },
          [
            !_vm.isStore
              ? _c("el-table-column", {
                  attrs: { align: "center", type: "selection", fixed: "" },
                })
              : _vm._e(),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "reportNo",
                label: _vm.$t("storeFeedback.report.reportNo"),
                "min-width": "200px",
                fixed: "",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "a-link",
                          on: {
                            click: function ($event) {
                              return _vm.showDetail(
                                scope.row.ttFeedbackReportId,
                                scope.row
                              )
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.row.reportNo))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "180px",
                prop: "supplierName",
                label: _vm.$t("storeFeedback.supplier"),
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "180px",
                prop: "materialName",
                label: _vm.$t("storeFeedback.materialName"),
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "90px",
                sortable: "",
                prop: "problemLevel",
                align: "center",
                label: _vm.$t("storeFeedback.problemLevel"),
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "90px",
                sortable: "",
                prop: "finalResponsibleParty",
                align: "center",
                label: "责任方",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm._f("ic")(
                            scope.row.finalResponsibleParty,
                            "TT_FEEDBACK_REPORT",
                            "FINAL_RESPONSIBLE_PARTY"
                          )
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "90px",
                sortable: "",
                prop: "isRepeat",
                align: "center",
                label: _vm.$t("storeFeedback.isRepeat"),
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "180px",
                prop: "storeName",
                label: _vm.$t("storeFeedback.storeName"),
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "100px",
                prop: "processNode",
                label: _vm.$t("storeFeedback.feedbackStatus"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm._f("ic")(
                            scope.row.processNode,
                            "TT_FEEDBACK",
                            _vm.fieldValue
                          )
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "80px",
                prop: "consumeType",
                label: _vm.$t("storeFeedback.consumeType"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm._f("ic")(
                            scope.row.consumeType,
                            "TT_FEEDBACK",
                            "CONSUME_TYPE"
                          )
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "80px",
                prop: "firstSubmitDate",
                label: _vm.$t("storeFeedback.SubmitDate"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm._f("dateFormatFilter")(
                            scope.row.firstSubmitDate,
                            "YYYY-MM-DD"
                          )
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "120px",
                prop: "feedbackNo",
                label: _vm.$t("storeFeedback.report.feedbackNo"),
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "80px",
                prop: "dcName",
                label: _vm.$t("storeFeedback.dcName"),
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "80px",
                prop: "materialCode",
                label: _vm.$t("storeFeedback.materialCode"),
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "70px",
                prop: "sourceCode",
                label: _vm.$t("storeFeedback.feedbackChannel"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm._f("ic")(
                            scope.row.sourceCode,
                            "TT_FEEDBACK",
                            "SOURCE_CODE"
                          )
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "130",
                prop: "storeNo",
                label: _vm.$t("storeFeedback.storeNo"),
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "70",
                prop: "isDirectSale",
                label: _vm.$t("storeFeedback.isDirectSale"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm._f("ic")(
                            scope.row.isDirectSale,
                            "COMMON",
                            "YES_NO"
                          )
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "100",
                prop: "reportStatus",
                label: _vm.$t("storeFeedback.report.reportStatus"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm._f("ic")(
                            scope.row.reportStatus,
                            "TT_FEEDBACK_REPORT",
                            "STATUS"
                          )
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm.isSUP || _vm.isMCD
              ? _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": "",
                    "min-width": "100px",
                    prop: "supplierCostTime",
                    label: _vm.$t("storeFeedback.supplierCostTime"),
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                (scope.row.supplierCostTime / 60).toFixed(2)
                              )
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    551136207
                  ),
                })
              : _vm._e(),
            _vm.isMCD
              ? _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": "",
                    "min-width": "100px",
                    prop: "storeCostTime",
                    label: _vm.$t("storeFeedback.report.storeTime"),
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s((scope.row.storeCostTime / 60).toFixed(2))
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3967815748
                  ),
                })
              : _vm._e(),
            _vm.isMCD
              ? _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": "",
                    "min-width": "100px",
                    prop: "cqscostTime",
                    label: _vm.$t("storeFeedback.report.mcdOperateTime"),
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s((scope.row.cqscostTime / 60).toFixed(2))
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2525118362
                  ),
                })
              : _vm._e(),
            _vm.isFBC || _vm.isMCD
              ? _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": "",
                    "min-width": "100px",
                    prop: "fbccostTime",
                    label: _vm.$t("storeFeedback.report.fbcOperateTime"),
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s((scope.row.fbccostTime / 60).toFixed(2))
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    4112019708
                  ),
                })
              : _vm._e(),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "90px",
                prop: "auditor",
                align: "center",
                label: _vm.$t("storeFeedback.auditor"),
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "120px",
                prop: "categoryLevel1Name",
                align: "center",
                label: "Category Level1",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "120px",
                prop: "categoryLevel2Name",
                align: "center",
                label: "Category Level2",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "100",
                prop: "commitDate",
                label: _vm.$t("storeFeedback.createDate"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm._f("dateFormatFilter")(
                            scope.row.commitDate,
                            "YYYY-MM-DD"
                          )
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.queryCondition.pageNum,
                "page-sizes": _vm.pageSizeList,
                "page-size": _vm.queryCondition.pageSize,
                layout: _vm.pageLayout,
                total: _vm.totalCount,
              },
              on: {
                "size-change": _vm.pageSizeChange,
                "current-change": _vm.pageNumberChange,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }